var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeaturesTwo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28Z",
    fill: "#EBE0D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3333 23.334H18.6667C18.0223 23.334 17.5 23.8563 17.5 24.5007V26.834C17.5 27.4783 18.0223 28.0007 18.6667 28.0007H37.3333C37.9777 28.0007 38.5 27.4783 38.5 26.834V24.5007C38.5 23.8563 37.9777 23.334 37.3333 23.334Z",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 23.334V38.5007",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1663 28V36.1667C36.1663 36.7855 35.9205 37.379 35.4829 37.8166C35.0453 38.2542 34.4518 38.5 33.833 38.5H22.1663C21.5475 38.5 20.954 38.2542 20.5164 37.8166C20.0788 37.379 19.833 36.7855 19.833 36.1667V28",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7497 23.3338C21.9761 23.3338 21.2343 23.0266 20.6873 22.4796C20.1403 21.9326 19.833 21.1907 19.833 20.4172C19.833 19.6436 20.1403 18.9018 20.6873 18.3548C21.2343 17.8078 21.9761 17.5005 22.7497 17.5005C23.8751 17.4809 24.978 18.027 25.9145 19.0675C26.851 20.1081 27.5777 21.5948 27.9997 23.3338C28.4217 21.5948 29.1483 20.1081 30.0848 19.0675C31.0213 18.027 32.1242 17.4809 33.2497 17.5005C34.0232 17.5005 34.7651 17.8078 35.3121 18.3548C35.8591 18.9018 36.1663 19.6436 36.1663 20.4172C36.1663 21.1907 35.8591 21.9326 35.3121 22.4796C34.7651 23.0266 34.0232 23.3338 33.2497 23.3338",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesTwo);
export default __webpack_public_path__ + "static/media/features-two.eac7c23d7549e710a5172ae11b214b62.svg";
export { ForwardRef as ReactComponent };